var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14622 9.14605L13.6366 4.65568V28.6364C13.6366 29.3895 14.2471 30 15.0002 30C15.7533 30 16.3639 29.3895 16.3639 28.6364V4.65568L20.8542 9.14605C20.9807 9.27288 21.131 9.37346 21.2964 9.44201C21.4619 9.51056 21.6393 9.54573 21.8184 9.5455C21.9975 9.54573 22.1749 9.51056 22.3404 9.44201C22.5058 9.37346 22.6561 9.27288 22.7826 9.14605C23.3151 8.61359 23.3151 7.75014 22.7826 7.21759L15.9644 0.399409C15.432 -0.133136 14.5685 -0.133136 14.036 0.399409L7.21777 7.21759C6.68522 7.75004 6.68522 8.6135 7.21777 9.14605C7.75031 9.6785 8.61377 9.6785 9.14622 9.14605Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.8ff907cf595d28e7d732a11066cc7378.svg";
export { ForwardRef as ReactComponent };